<div tabindex="0" class="me-register-form">
    <div class="me-register-form__header">
        {{ 'Your personal data' | translate}}
    </div>
    <div class="me-register-form__description">
        {{ 'We need this to create your profile.' | translate}}
    </div>
    <form [formGroup]="form">
        <div class="row">
            <div class="col-xs-12">
                <div class="me-form-input-group">
                    <div class="me-form-input" [class.error]="!(form.controls.name.valid
                    || (form.controls.name.pristine && !submitted))">
                        <label class="me-form-input__label">{{'Given Name' | translate}}*</label>
                        <input title="{{'Please fill out this field.' | translate}}" [attr.aria-label]="'Given Name' | translate" formControlName="name" class="me-form-input__input" />
                    </div>
                    <small [hidden]="form.controls.name.valid
                    || (form.controls.name.pristine && !submitted)"
                    class="me-form-input__error">
                        {{ 'This field is required.' | translate }}
                    </small>
                </div>
            </div>
            <div class="col-xs-12">
                <div class="me-form-input-group">
                    <div class="me-form-input" [class.error]="!(form.controls.surname.valid
                    || (form.controls.surname.pristine && !submitted))">
                        <label class="me-form-input__label">{{ 'Surname' | translate }}*</label>
                        <input title="{{'Please fill out this field.' | translate}}" [attr.aria-label]="'Surname' | translate" formControlName="surname" class="me-form-input__input" />
                    </div>
                    <small [hidden]="form.controls.surname.valid
                    || (form.controls.surname.pristine && !submitted)"
                    class="me-form-input__error">
                        {{ 'This field is required.' | translate }}
                    </small>
                </div>
            </div>
            <div class="col-xs-12">
                <div class="me-form-input-group">
                    <div class="me-form-input" [class.error]="!(form.controls.email.valid
                    || (form.controls.email.pristine && !submitted)) || invalidEmail">
                        <label class="me-form-input__label">{{ 'Email Address' | translate }}*</label>
                        <input title="{{'Please fill out this field.' | translate}}" [attr.aria-label]="'Email Address' | translate" formControlName="email" class="me-form-input__input" />
                    </div>
                    <small [hidden]="form.controls.email.valid
                    || (form.controls.email.pristine && !submitted)"
                    class="me-form-input__error">
                        {{ 'The email is not valid' | translate }}
                    </small>
                    <small [hidden]="!invalidEmail"
                    class="me-form-input__error">
                        {{ 'The email already exists' | translate }}
                    </small>
                </div>
            </div>
            <div class="col-xs-12">
                <div class="me-form-input-group">
                    <div class="me-form-input" [class.error]="!(form.controls.birthday.valid || (form.controls.birthday.pristine && !submitted)) || errorAge">
                        <label class="me-form-input__label">{{ 'Date of Birth' | translate }}*</label>
                        <input title="{{'Please fill out this field.' | translate}}" [attr.aria-label]="'Date of Birth' | translate" type="date" formControlName="birthday" class="me-form-input__input" (change)="onBirthdayChanged($event.target.value)"/>
                    </div>
                    <small [hidden]="form.controls.birthday.valid
                    || (form.controls.birthday.pristine && !submitted)"
                    class="me-form-input__error">
                        {{ 'This field is required.' | translate }}
                    </small>
                    <small [hidden]="!errorAge"
                    class="me-form-input__error">
                        {{ 'Only accessible to people over 18 years of age' | translate }}
                    </small>
                </div>
            </div>
            <div class="col-xs-12">
                <div class="gender-label" tabindex="0">{{ 'Gender identity' | translate}}</div>
                <div class="gender-selected" role="radiogroup" tabindex="0">
                    <div (keyup.enter)="selectGender(gender['value'])" *ngFor="let gender of genders"
                         tabindex="0" role="radio"
                         [attr.aria-checked]="form.controls.gender.value == gender['value'] ? 'true' : 'false'">
                        <input type="radio" id="gender-{{ gender['value'] }}"
                            [value]="gender['value']" formControlName="gender"/>
                        <label id="gender-{{gender['value']}}-label" class="gender-selected__label" for="gender-{{ gender['value'] }}">
                            {{ gender['name'] | translate }}
                        </label>
                    </div>
                </div>
            </div>
            <div class="col-xs-12 me-register-form__required">
                *{{ 'Required field' | translate}}
            </div>
        </div>
    </form>
    <div class="me-register-form__button">
        <button class="btn btn--primary me-register-form__button__mobile" [class.disabled]="!form.valid || errorAge" (click)="submit(form.value, form.valid)">
            {{'Continue' | translate}}
        </button>
        <button class="btn btn--secondary" (click)="meRegisterService.step = 2;">
            {{ 'Back' | translate}}
        </button>
    </div>
</div>